module.exports = __webpack_public_path__ + "static/media/pg_tidepool_closeup_bg.9f1c7788.jpg";